import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class NoteService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
  }

  public addNote(note) {
    return this.http.post<RequestResponse>(this.getUrl('addNote'), note);
  }
  
  public deleteNote(note) {
    return this.http.post<RequestResponse>(this.setUrl('deleteNote'), note);
  }

  public getNotesByAdmin(q) {
    return this.http.post<RequestResponse>(this.setUrl('fullNoteList'), q);
  }

  public myNotes(data) {
 
    return this.http.post<RequestResponse>(this.getUrl('myNotes'), data).pipe();
  }
  public getMyNoteById(id) {
    const options = id ? { params: new HttpParams().set('id', id.toString()) } : {};
    return this.http.get<RequestResponse>(this.getUrl('getMyNoteById'), options);
  }
  public getNoteById(id) {
    const options = id ? { params: new HttpParams().set('id', id.toString()) } : {};
    return this.http.get<RequestResponse>(this.getUrl('getNoteById'), options);
  }

  public getEditNoteById(id) {
    const options = id ? { params: new HttpParams().set('id', id.toString()) } : {};
    return this.http.get<RequestResponse>(this.getUrl('getEditNoteById'), options);
  }

  public getNotesByFilters(filters) {
    const options = filters ? { params: new HttpParams().set('filters', JSON.stringify(filters)) } : {};
    return this.http.get<RequestResponse>(this.getUrl('getNotesByFilters'), options);
  }
  public getNotesRecentPopular() {
    return this.http.get<RequestResponse>(this.getUrl('getNotesRecentPopular'));
  }

  public getNotesByCategory(data: object) {
    return this.http.post<RequestResponse>(this.getUrl('getNotesByCategory'), data);
  }

  public getArrangerGrossCommision(data) {
    return this.http.post<RequestResponse>(this.getUrl('getArrangerGrossCommision'), data);
  }

  public rateNote(data) {
    return this.http.post<RequestResponse>(this.getUrl('rateNote'), data);
  }
}
